import { bytesToString } from "@/utils/utils";
/**
 * Contains information about the result of the cleaning operation.
 */
export class CleanupResult {
    constructor(data = { totalFreeBytes: 0, totalItemCount: 0, errors: [] }) {
        Object.defineProperty(this, "_data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._data = data;
    }
    get totalItemCount() {
        return this._data.totalItemCount;
    }
    get totalFreeBytes() {
        return this._data.totalFreeBytes;
    }
    get errors() {
        return this._data.errors;
    }
    get errorMessage() {
        return this._data.errorMessage;
    }
    /**
     * Whether the cleanup operation yielded some errors.
     * It doesn't mean the operation completely failed.
     * @returns {boolean}
     */
    get hasSomeErrors() {
        return this._data.errors.length > 0;
    }
    /**
     * Whether the cleanup operation completely failed.
     * This means not even partial cleaning was made.
     * @returns {boolean}
     */
    get hasFailed() {
        return Boolean(this._data.errorMessage);
    }
    /**
     * Whether the cleanup operation was executed without errors.
     * @returns {boolean}
     */
    get success() {
        return !this.hasSomeErrors && !this._data.errorMessage;
    }
    /**
     * The number of items successfully cleaned.
     * @returns {number}
     */
    get totalCleaned() {
        return this._data.totalItemCount - this._data.errors.length;
    }
    /**
     * Whether the cleanup operation managed to
     * free some items but not all of them.
     * @returns {boolean}
     */
    get isPartialSuccess() {
        return this._data.errors.length > 0 && this.totalCleaned > 0;
    }
    /**
     * The total amount of disk space freed by the cleanup operation.
     * @returns {String}
     */
    get niceTotalFreeBytes() {
        return bytesToString(this._data.totalFreeBytes, true, undefined);
    }
}
